export default __webpack_public_path__ + "static/media/timbs.b448023b.webp";